// TODO: Supporting only 'dialog.submit' message in Standlone from child window for now.
export enum HostMessageType {
  DialogSubmit = 'dialogs.submit',
}

/**
 * IMessageHandler
 */
export interface IMessageHandler {
  /**
   * Provides deleting message handling from the handler
   */
  canHandleMessage(message: string): boolean;

  /**
   * Provides handling message
   */
  handleMessage(message: string, ...args: unknown[]): Promise<void>;

  /**
   * Initializes the handlers
   */
  initHandlers(): void;

  /**
   * Perform any necessary cleanup
   */
  cleanup(): void;
}

export type HandlerType = (...args: unknown[]) => Promise<void>;
